export function getZeblineUserId() {
    try {
        return window.zebline.user.getUserId();
    } catch (err) {
    }
}

export function zeblineLogin(...args: any[]) {
    try {
        window.zebline.user.login(...args);
    } catch (err) {
    }
}